import React from 'react';
import { RichText, withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import WebinarCardNPM from '@rotaryintl/myrotary-webinar-card';

const WebinarCard = ({
  sitecoreContext,
  fields: { Title, DateField, TimeField, Duration, BodyCopy, Language, InterpretedLanguages, RegisterLink, ViewLink, HelperText, Hide } = {},
}) => {
  if (Hide?.value === true) return null;

  const lang = sitecoreContext?.language;
  const isUpcoming = variant === 'upcoming';
  const metaLabel = isUpcoming
    ? buildUpcomingMetaLabel(lang, DateField?.value, TimeField?.value, Duration?.value)
    : buildOnDemandMetaLabel(lang, DateField?.value, Duration?.value);
  const interpretedLanguages =
    typeof InterpretedLanguages?.value === 'string'
      ? InterpretedLanguages.value
          .split(',')
          .map((lang) => lang.trim())
          .filter(Boolean)
      : [];

  return (
    <WebinarCardNPM
      variant={isUpcoming ? 'upcoming' : 'ondemand'}
      title={Title?.value}
      dateLabel={isUpcoming ? metaLabel : undefined}
      onDemandMetaLabel={!isUpcoming ? metaLabel : undefined}
      bodyCopy={BodyCopy?.value ? <RichText field={BodyCopy} /> : undefined}
      primaryLanguage={Language?.value}
      interpretedLanguages={interpretedLanguages}
      viewLink={!isUpcoming ? ViewLink?.value : undefined}
      registerLink={isUpcoming ? RegisterLink?.value : undefined}
      showHelperText={!isUpcoming ? HelperText?.value : undefined}
    />
  );
};

export default withSitecoreContext()(WebinarCard);
 